import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isApiValidationError } from 'src/config/request/fetcher/error';
import { DataHubService } from 'src/core/services/datahub';
import { useBulkDelete } from 'src/modules/contentList/components/bulkActions/hooks/useBulkActions/useBulkDelete';
import { useBulkPublish } from 'src/modules/contentList/components/bulkActions/hooks/useBulkActions/useBulkPublish';
import { useBulkUnpublish } from 'src/modules/contentList/components/bulkActions/hooks/useBulkActions/useBulkUnpublish';
import { SelectedContentContext } from 'src/modules/contentList/contexts/selectedContentContext';
import { BulkAction } from 'src/modules/contentList/types';
import { Toast } from 'src/shared/components/toast';
export function useBulkActions() {
    const { t } = useTranslation();
    const { selectAll } = useContext(SelectedContentContext);
    const [activeBulkAction, setActiveBulkAction] = useState(null);
    const actions = {
        [BulkAction.Publish]: useBulkPublish(),
        [BulkAction.Unpublish]: useBulkUnpublish(),
        [BulkAction.Delete]: useBulkDelete()
    };
    const onClose = () => {
        setActiveBulkAction(null);
        selectAll(false);
        // TODO: Remove after list rollout
        window.dispatchEvent(new CustomEvent('app-content-admin:bulkactionsmenu:closed'));
    };
    const onCancel = () => {
        setActiveBulkAction(null);
    };
    const onConfirm = (action, payload) => {
        return async (notShowAgainValue) => {
            if (!action) {
                return;
            }
            try {
                await actions[action].mutation.mutateAsync(payload);
                selectAll(false);
            }
            catch (error) {
                const message = (isApiValidationError(error) && t(`error_codes.${error.extra.errorCode}`)) ||
                    t('error_boundary.title');
                Toast.show({ type: 'danger', message });
                return;
            }
            const updateList = true;
            setActiveBulkAction(null);
            // TODO: Remove after list rollout
            window.dispatchEvent(new CustomEvent('app-content-admin:bulkactionsmenu:closed', { detail: updateList }));
            Toast.show({ type: 'success', message: actions[action].successMessage });
            if (actions[action].datahubSchema) {
                DataHubService.sendEvent({
                    schema: new actions[action].datahubSchema({
                        pages: payload.pages.length,
                        modules: payload.modules.length,
                        arrivedFrom: window.location.href
                    })
                });
            }
            if (notShowAgainValue) {
                actions[action].notShowAgain.saveNotShowAgain();
            }
        };
    };
    const onClick = (action, payload) => {
        return () => {
            if (actions[action].notShowAgain.notShowAgain.current) {
                onConfirm(action, payload)(false);
            }
            else {
                setActiveBulkAction(action);
            }
        };
    };
    return {
        activeBulkAction,
        onClose,
        onCancel,
        onConfirm,
        onClick,
        isPending: {
            [BulkAction.Publish]: actions[BulkAction.Publish].mutation.isPending,
            [BulkAction.Unpublish]: actions[BulkAction.Unpublish].mutation.isPending,
            [BulkAction.Delete]: actions[BulkAction.Delete].mutation.isPending
        }
    };
}
